// extracted by mini-css-extract-plugin
export var borderRadius = "_ad-4";
export var large = "_ad-3";
export var logoContainer = "_ad-0";
export var nameLogo = "_ad-2";
export var small = "_ad-1";